export default __webpack_public_path__ + "static/media/company.310c101d.svg";